export default function (queryParams: string[], url?: string | URL) {
    const search = url ? new URL(url).search : window.location.search;
    const urlParams = new URLSearchParams(search);

    if (!Array.isArray(queryParams)) {
        throw new TypeError("queryParams must be an array");
    }

    return queryParams.reduce(
        (queryMap: Record<string, string | string[] | null>, queryName) => {
            const values = urlParams.getAll(queryName);

            if (values.length === 0) {
                queryMap[queryName] = null;
            } else if (values.length === 1) {
                queryMap[queryName] = values[0] ?? null;
            } else {
                queryMap[queryName] = values;
            }

            return queryMap;
        },
        {},
    );
}
